import HeroCarousel from "./components/HeroCarousel";
import QuickEntries from "./components/QuickEntries";
import NewsSection from "./components/NewsSection";
import VideoSection from "./components/VideoSection";
import GameSection from "./components/GameSection";
import ForumTopics from "./components/ForumTopics";
import AboutStrip from "./components/AboutStrip";

export default function Home() {
  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <h1 className="sr-only">天天干天天干 - 多元化娱乐资讯与互动社区</h1>

      <div className="animate-fade-up">
        <HeroCarousel />
      </div>

      <div className="mt-8 animate-fade-up md:mt-10">
        <QuickEntries />
      </div>

      <div className="mt-12 md:mt-16">
        <NewsSection />
      </div>

      <div className="mt-12 md:mt-16">
        <VideoSection />
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 md:mt-16 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <GameSection />
        </div>
        <div>
          <ForumTopics />
        </div>
      </div>

      <div className="mt-12 md:mt-16">
        <AboutStrip />
      </div>
    </div>
  );
}